import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import placeImage from "../../images/placeholder.jpg";
import NumberFormatter from "../../Component/NumberFormatter";
import axios from "axios";
import config from "../../config";
import Dataloader from "../../Component/Dataloader";
import NoData from "../../Component/NoData";

export default function ProductList() {
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };
  const params = useParams();
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState([]);

  const fetchProductList = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/seller-list-by-commodity-product/${params.id}`
      );
      setProductData(response.data.data);
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setExist(false);
      }
    } finally {
      setLoading(false);
    }
  }, [params.id]);

  useEffect(() => {
    fetchProductList();
  }, [fetchProductList]);

  return (
    <>
      <div className="page-content">
        <div className="product-hero-area">
          <div className="product-hero-content">
            <h4>All products list</h4>
            <p className="mb-0">
              Showing {productData.length} product from your search
            </p>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row-layout mrty1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                {productData.length > 0 && exist ? (
                  <div className="row g-3">
                    {productData.map((data, index) => {
                      return (
                        <div
                          className="col-lg-3 col-md-4 col-6 px-2"
                          key={index}
                        >
                          <div className="product-area">
                            <Link to={`/product-detail/${data.id}`}>
                              <div className="home-product">
                                <div className="product-image">
                                  <img
                                    src={data.thumbnail}
                                    onError={imageOnError}
                                    alt="product"
                                  />
                                </div>
                                <div className="row product-detail">
                                  <div className="col-12">
                                    <h6 className="one-line-clamp">
                                      {data.name}
                                    </h6>
                                  </div>
                                  <div className="col-12">
                                    <div className="product-tag">
                                      <div>
                                        <span className="f-500">Brand:</span>
                                        <span>{data.brand}</span>
                                      </div>
                                      <div>
                                        <span className="f-500">Quality:</span>
                                        <span>
                                          {data.quality &&
                                          data.quality.length > 0
                                            ? data.quality[0]
                                            : "--"}
                                        </span>
                                      </div>
                                      <div>
                                        <span className="f-500">Size:</span>
                                        <span>
                                          {data.default_variation &&
                                          data.default_variation[0]
                                            ? data.default_variation[0].value +
                                              " " +
                                              data.default_variation[0].unit
                                                .short_name
                                            : "--"}
                                        </span>
                                      </div>
                                      <div>
                                        <span className="f-500">Location:</span>
                                        <span>Ex-{data.city}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row rate-area">
                                  <div className="col-6">
                                    <h6>
                                      Rs{" "}
                                      <NumberFormatter number={data.ex_price !== 0 ? data.ex_price : data.base_price} />
                                      /{data.unit_name}
                                    </h6>
                                    <span>GST & other charges included</span>
                                  </div>
                                  <div className="col-6">
                                    {data.price_validity && (
                                      <h6>
                                        Price Validity Till <br />
                                        <span>{data.price_validity}</span>
                                      </h6>
                                    )}
                                  </div>
                                  <div className="col-12">
                                    <button className="price-statusup btn">
                                      Get Best Price
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-lg-12">
                      <NoData />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
